import React from 'react'
import List from '../components/List'
import hipladeTemplate from '../../common/template'

function MyEventsList() {
  return <List />
}

export default hipladeTemplate(MyEventsList)
